/**
 * CompletionConditionToggle Component
 *
 * One completion condition: a switch named by the condition, with an optional explanation below.
 */
import { Toggle } from '@insio/ui-toolkit';

export interface CompletionConditionToggleProps {
  label: string;
  description?: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
  testId: string;
}

export function CompletionConditionToggle({
  label,
  description,
  checked,
  disabled,
  onChange,
  testId
}: CompletionConditionToggleProps) {
  return (
    <div className='space-y-xs'>
      <Toggle
        labelText={label}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        className='shrink-0'
        testId={testId}
      />
      {description && <p className='text-sm text-foreground-muted'>{description}</p>}
    </div>
  );
}
